import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { handle_activePage } from "../../Redux/reducer";
import QR_DL from "../../assets/QR_DL.png"; // adjust path if needed


const DL_Course = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(handle_activePage("Deep Learning Course"));
    window.scrollTo(0, 0);
  }, [dispatch]);

  return (
    <>
      <style>{`
        /* ---------- Page Layout ---------- */
        .dl-page {
          width: 100%;
          min-height: 100vh;
          display: flex;
          flex-direction: row;
          font-family: "Poppins", sans-serif;
          overflow: hidden;
        }

        /* ---------- Left (Blue) ---------- */
        .dl-left {
          flex: 1;
          background-color: #0d57a1;
          color: #f8c100;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding: 120px 60px 80px 60px;
          box-sizing: border-box;
        }

        /* Title Animation */
        .dl-title {
          font-size: 3rem;
          font-weight: 700;
          margin-bottom: 2rem;
          opacity: 0;
          position: relative;
          animation: fadeSketch 2.5s ease forwards;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        @keyframes fadeSketch {
          0% {
            opacity: 0;
            filter: blur(3px);
            transform: scale(0.95);
            text-shadow: 0 0 10px rgba(255, 215, 0, 0.2);
          }
          50% {
            opacity: 1;
            filter: blur(0);
            transform: scale(1.02);
            text-shadow: 0 0 15px rgba(255, 215, 0, 0.4);
          }
          100% {
            opacity: 1;
            transform: scale(1);
            text-shadow: 0 0 5px rgba(255, 215, 0, 0.2);
          }
        }

        /* Bullet Points */
        .dl-points {
          list-style: disc;
          list-style-position: inside;
          padding: 0;
          margin: 0;
          color: #fff;
          text-align: left;
          font-size: 1.15rem;
          max-width: 700px;
          line-height: 1.8;
        }

        .dl-points li {
          opacity: 0;
          transform: translateY(10px);
          animation: fadeUp 0.8s ease forwards;
          margin-bottom: 10px;
        }

        .dl-points li:nth-child(1) { animation-delay: 0.8s; }
        .dl-points li:nth-child(2) { animation-delay: 1.3s; }
        .dl-points li:nth-child(3) { animation-delay: 1.8s; }
        .dl-points li:nth-child(4) { animation-delay: 2.3s; }

        @keyframes fadeUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Instructor */
        .dl-instructor {
          margin-top: 2.5rem;
          opacity: 0;
          animation: fadeIn 2s ease forwards;
          animation-delay: 3s;
          display: flex;
          flex-direction: column;
          line-height: 1.5;
          color: #fff;
        }

        .dl-instructor span:first-child {
          font-size: 1rem;
          color: #f8c100;
          letter-spacing: 1px;
          margin-bottom: 4px;
        }

        .dl-instructor span:nth-child(2) {
          font-size: 1.4rem;
          font-weight: 600;
        }

        .dl-instructor span:nth-child(3) {
          font-size: 1rem;
          opacity: 0.9;
        }

        @keyframes fadeIn {
          to { opacity: 1; }
        }

        /* ---------- Right (Yellow) ---------- */
        .dl-right {
          flex: 1;
          background-color: #f8c100;
          color: #0d57a1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          padding: 120px 40px 80px 40px;
          box-sizing: border-box;
        }

        .dl-right h2 {
          font-size: 2.3rem;
          margin-bottom: 1.5rem;
          font-weight: 700;
          opacity: 0;
          animation: fadeIn 1.5s ease forwards;
          animation-delay: 1.2s;
        }

        .qr-box {
          width: 200px;
          height: 200px;
          background: #fff;
          border-radius: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 600;
          color: #333;
          opacity: 0;
          transform: translateY(10px);
          animation: fadeUp 1.2s ease forwards;
          animation-delay: 1.6s;
        }

        /* ---------- Responsive (Mobile) ---------- */
        @media (max-width: 900px) {
          .dl-page {
            flex-direction: column;
            min-height: auto;
          }

          .dl-left, .dl-right {
            width: 100%;
            min-height: 100vh;
            align-items: center;
            text-align: center;
            padding: 100px 20px 100px 20px;
          }

          .dl-left h1 {
            font-size: 2rem;
          }

          .dl-points {
            font-size: 1rem;
            max-width: 90%;
          }

          .dl-instructor {
            align-items: center;
          }

          .dl-right h2 {
            font-size: 1.8rem;
          }

          .qr-box {
            width: 160px;
            height: 160px;
          }
        }
      `}</style>

      <div className="dl-page">
        {/* Left Section - Course Details */}
        <div className="dl-left">
          <h1 className="dl-title">Deep Learning Course</h1>
          <ul className="dl-points">
            <li>Master the fundamentals of how deep learning models work.</li>
            <li>Learn key architectures such as CNNs, RNNs, GANs, and more.</li>
            <li>Gain practical insights from real-world AI projects.</li>
            <li>Connect and network with AI experts in the field.</li>
          </ul>

          <div className="dl-instructor">
            <span>By</span>
            <span>Abhishek Rishikeshan</span>
            <span>2X AI-based startup founder and Ex-Intel</span>
          </div>
        </div>

        {/* Right Section - Register */}
        <div className="dl-right">
          <h2>Register Now</h2>
          <div className="qr-box"><img src={QR_DL} alt="Download QR" className="qr-img" /></div>
        </div>
      </div>
    </>
  );
};

export default DL_Course;
